import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { IMAGES } from "@/config/content";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/admin");
  };

  const inputCls = "w-full rounded-sm border border-gold/30 bg-ink px-4 py-4 text-lg text-ivory focus:border-gold";

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-20 bg-ink">
      <form onSubmit={submit} className="w-full max-w-md border border-gold/30 bg-ink2 p-8 rounded-sm" data-testid="admin-login-form">
        <div className="flex flex-col items-center text-center">
          <img src={IMAGES.logo} alt="EHSIMFFA seal" className="h-16 w-16" />
          <h1 className="mt-4 font-serif text-3xl text-ivory">Admin Dashboard</h1>
          <p className="mt-1 text-sm text-ivory2/70">EHSIMFFA · Sign in to continue</p>
        </div>
        <div className="mt-8 space-y-5">
          <div>
            <label htmlFor="a-email" className="mb-2 block text-sm font-semibold uppercase tracking-wider text-ivory2">Email</label>
            <input id="a-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email" />
          </div>
          <div>
            <label htmlFor="a-pass" className="mb-2 block text-sm font-semibold uppercase tracking-wider text-ivory2">Password</label>
            <input id="a-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password" />
          </div>
          {error && <p className="text-ethred text-sm" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="flex w-full items-center justify-center gap-3 rounded-sm bg-gold py-4 text-base font-bold uppercase tracking-wider text-ink hover:bg-goldhi disabled:opacity-70">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-5 w-5" />} Sign In
          </button>
        </div>
      </form>
    </div>
  );
}
